export const en = {
  common: {
    language: 'Language',
    login: 'Login',
    signup: 'Sign up',
    logout: 'Logout',
    dashboard: 'Dashboard',
    or: 'or',
    learnMore: 'Learn more',
    back: 'Back',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Operation successful',
  },
  nav: {
    services: 'Our Services',
    history: 'Our History',
    fleet: 'Our Fleet',
    team: 'Our Team',
    contact: 'Contact',
    becomeDriver: 'Become a Driver',
    about: 'About'
  },
  dashboard: {
    driver: 'Driver',
    passenger: 'Passenger',
    stats: 'Statistics',
    trips: 'Trips',
    upcomingTrips: 'Upcoming trips',
    tripHistory: 'Trip history',
    profile: 'My profile',
    payment: 'Payment',
    noTrips: 'No upcoming trips',
    noTripsDescription: 'You don\'t have any scheduled trips at the moment.'
  },
  auth: {
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    forgotPassword: 'Forgot password?',
    noAccount: 'Don\'t have an account?',
    haveAccount: 'Already have an account?',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    emailPlaceholder: 'Your email address',
    passwordPlaceholder: 'Your password',
    loginToBookTrips: 'Login to book your trips',
    loginToAccessDashboard: 'Login to access your dashboard',
    continueWithGoogle: 'Continue with Google',
    continueWithApple: 'Continue with Apple',
    termsAgreement: 'By logging in, you agree to our',
    termsOfUse: 'Terms of Use',
    andOur: 'and our',
    privacyPolicy: 'Privacy Policy'
  },
  booking: {
    pickup: 'Pickup location',
    dropoff: 'Dropoff location',
    date: 'Date',
    time: 'Time',
    passengers: 'Passengers',
    book: 'Book',
    bookNow: 'Book now'
  },
  status: {
    pending: 'Pending',
    accepted: 'Accepted',
    ongoing: 'Ongoing',
    completed: 'Completed',
    cancelled: 'Cancelled'
  },
  app: {
    home: 'Home',
    book: 'Book',
    activity: 'Activity',
    profile: 'Profile',
    favorites: 'Favorite addresses',
    addFavorite: 'Add address',
    useAddress: 'Use this address',
    delete: 'Delete',
    noFavorites: 'No favorite addresses',
    settings: 'Settings',
    preferences: 'Preferences',
    notifications: 'Notifications',
    darkMode: 'Dark mode',
    language: 'Language',
    account: 'Account',
    paymentMethods: 'Payment methods',
    privacy: 'Privacy',
    support: 'Support',
    help: 'Help'
  },
  home: {
    hero: {
      title: 'Welcome to',
      desc: 'The best transportation experience for all your journeys. Professional, punctual and comfortable service.'
    },
    booking: {
      type: {
        ride: 'A ride',
        hourly: 'Hourly'
      },
      input: {
        origin: 'Departure address',
        destination: 'Destination address',
        departureDate: 'Departure date',
        departureTime: 'Departure time',
        returnDate: 'Return date',
        returnTime: 'Return time'
      },
      action: {
        addReturn: 'ADD RETURN',
        calculating: 'CALCULATING',
        search: 'SEARCH'
      },
      error: {
        departureMustBeFuture: 'The departure time must be in the future',
        returnMustBeAfterDeparture: 'The return date cannot be before the departure date',
        selectValidAddresses: 'Please select valid departure and arrival addresses',
        cannotCalculateRoute: 'Unable to calculate the route. Please try again.',
        addressesRequired: 'Please enter the departure and arrival addresses'
      },
      info: {
        distance: 'Distance',
        duration: 'Estimated duration',
        price: 'Estimated price'
      }
    },
    services: {
      title: 'Our Services',
      subtitle: 'Transport solutions tailored to your needs',
      description: 'At TaxiMoove, we are committed to providing high-quality transport services tailored to your needs. Our fleet of modern vehicles and professional drivers are at your disposal to offer you a comfortable, secure and punctual transport experience.',
      book: 'Book now'
    },
    about: {
      title: 'Why choose TaxiMoove?',
      description: 'At TaxiMoove, we distinguish ourselves through our commitment to excellence and customer service. Our unique approach combines professionalism, innovation and personalization to offer you an incomparable transport experience.',
      details: {
        premium: {
          title: 'Premium Service',
          description: 'Our professional drivers are carefully selected and trained to provide you with superior quality service. Courteous, punctual and attentive, they adapt to your specific needs.'
        },
        security: {
          title: 'Guaranteed Safety',
          description: 'Your safety is our absolute priority. All our vehicles are regularly maintained and equipped with the latest safety technologies. Our drivers undergo continuous training in road safety.'
        },
        punctuality: {
          title: 'Punctuality',
          description: 'We understand that your time is precious. That\'s why we are committed to always being punctual. Our real-time tracking system allows us to inform you precisely of your driver\'s arrival.'
        },
        personalization: {
          title: 'Personalized Service',
          description: 'Every customer is unique, and we adapt our service to your specific needs. Whether for a regular or occasional journey, we create a tailor-made solution.'
        },
        price: {
          title: 'Transparent Pricing',
          description: 'No surprises with our rates. We practice clear and transparent prices, with no hidden fees. Our online price calculator allows you to know the exact cost of your journey before booking.'
        },
        region: {
          title: 'Complete Coverage',
          description: 'We serve the entire region with a fleet of modern and comfortable vehicles. Whether you are in the city or in the suburbs, we are here to accompany you everywhere.'
        }
      },
      footer: {
        title: 'Quality Commitment',
        description: 'At TaxiMoove, we are committed to providing you with an exceptional transport experience. Customer satisfaction is our priority, and we never stop innovating to improve our services.'
      }
    },
    contact: {
      title: 'Ready to book your trip?',
      description: 'Our team is available to discuss your specific transport needs and propose a personalized solution. Don\'t hesitate to contact us for a free quote or to make a reservation.',
      action: 'Contact us'
    }
  },
  services: {
    hero: {
      title: 'Our Premium Transport Services',
      description: 'Discover our comprehensive range of transport services tailored to all your needs. From daily trips to airport transfers, we guarantee quality service.'
    },
    standard: {
      title: 'Standard Transport',
      description: 'Comfortable and reliable transport service for your daily or occasional trips.',
      descriptionLong: 'Premium taxi service for all your daily transportation needs. Whether for a business appointment, special event, or simply getting around town, our standard transport service guarantees comfort, punctuality, and professionalism.',
      features: [
        'Modern and comfortable vehicles',
        'Professional drivers',
        '24/7 service available'
      ]
    },
    airport: {
      title: 'Airport Transfers',
      description: 'Specialized transfer service for your trips to and from airports.',
      descriptionLong: 'Transfer service to and from airports in Belgium. We track your flight status to guarantee timely pickup, even in case of delays.',
      features: [
        'Real-time flight tracking',
        'Luggage assistance',
        'Family-friendly vehicles'
      ]
    },
    parcel: {
      title: 'Parcel Transport',
      description: 'Fast and secure delivery service for your packages and important documents.',
      descriptionLong: 'Fast and secure delivery service for your packages and important documents. We ensure pickup and delivery of your shipments within the best possible timeframes.',
      features: [
        'Real-time tracking',
        'Express delivery',
        'Courier service'
      ]
    },
    cta: {
      title: 'Ready to book your trip?',
      description: 'Enjoy our premium services now. Book in a few clicks and travel with peace of mind.',
      button: 'Book now'
    }
  },
  about: {
    title: 'About TaxiMoove',
    ourStory: {
      title: 'Our Story',
      description: 'Founded in 2020, TaxiMoove was born from the vision of offering a premium transport service combining comfort, safety and punctuality. Our commitment to excellence has enabled us to become a major player in private transport in Brussels.'
    },
    ourVehicles: {
      title: 'Our Fleet',
      description: 'Explore our variety of premium vehicles, designed to meet all your transport needs with comfort and style.'
    },
    ourTeam: {
      title: 'Our Team',
      description: 'Meet the passionate people who make exceptional quality service possible day after day.'
    },
    ourValues: {
      title: 'Our Values',
      subtitle: 'These principles guide each of our actions and are at the heart of our commitment to you',
      values: {
        premium: {
          title: 'Premium Customer Service',
          description: 'Your satisfaction is our absolute priority. We strive to exceed your expectations on every journey with personalized and attentive service.'
        },
        professional: {
          title: 'Professionalism',
          description: 'Our drivers are experienced professionals, trained to provide you with the highest quality service while respecting safety standards.'
        },
        excellence: {
          title: 'Excellence',
          description: 'We aim for excellence in every aspect of our service, from the cleanliness of our vehicles to the courtesy of our drivers and the reliability of our journeys.'
        }
      }
    },
    learnMore: 'Learn more'
  },
  ourStory: {
    title: 'Our Story',
    content: [
      'TaxiMoove was born from the meeting and friendship between two passionate engineers, Elias and Moukrim, who share a common vision: to reinvent urban transportation services to make them more equitable, more ecological, and more efficient.',
      'With their complementary backgrounds — Elias, a physics engineer specialized in photonics from ULB, and Moukrim, an electromechanical engineer specialized in transportation and vehicles from VUB — they combined their expertise to create an alternative to traditional services that addresses contemporary urban mobility challenges.',
      'Their story is one of an idea that matured over time, a friendship that transcends linguistic and cultural differences, and a shared ambition to create a positive impact on society.'
    ],
    timeline: {
      title: 'Our Journey',
      times: [
        {
          title: 'The Meeting',
          content: 'Elias from ULB and Moukrim from VUB, two engineering master\'s students, meet. Despite different backgrounds - Elias in physics specialized in photonics and Moukrim in electromechanics specialized in transportation and vehicles - they discover they share the same ambition to bring ecological and sustainable added value to society.'
        },
        {
          title: 'The Observation',
          content: 'As regular users of transportation services, Elias and Moukrim observe that existing solutions are suboptimal - both for customers and drivers, as well as for the environment. An idea begins to germinate.'
        },
        {
          title: 'The Beginning of the Adventure',
          content: 'Moukrim takes the leap and invests in purchasing his first taxis. Convinced of the potential of their shared vision, he reconnects with Elias to implement together the idea they had sketched years earlier.',
          time: 'Feb. 2024'
        },
        {
          title: 'The Birth of TaxiMoove',
          content: 'Elias and Moukrim combine their complementary skills - one French-speaking trained at ULB, the other Dutch-speaking graduated from VUB. This alliance symbolizes the very spirit of TaxiMoove: the convergence of different perspectives to create a more efficient and inclusive solution.',
          time: 'March 2024'
        },
        {
          title: 'Today',
          content: 'TaxiMoove offers a modern transportation service model, aligned with its founding values: competitive prices for users, fair commissions for drivers, less polluting vehicles, booking efficiency, and service excellence in all aspects.',
        }
      ]
    }
  },
  ourValues: {
    title: 'Our Values',
    description: 'At TaxiMoove, our founding values guide each of our actions and decisions, reflecting the vision of our co-founders Elias and Moukrim.',
    values: {
      ecology: {
        title: 'Environmental Sustainability',
        content: 'We are committed to reducing the environmental impact of urban transportation by prioritizing less polluting vehicles and eco-responsible driving practices.'
      },
      equity: {
        title: 'Equity',
        content: 'We believe in a balanced economic model, offering competitive prices to users while guaranteeing fair and transparent commissions to our partner drivers.'
      },
      innovation: {
        title: 'Innovation',
        content: 'Coming from engineering backgrounds, we apply our expertise to develop technological solutions that optimize every aspect of transportation service.'
      },
      excellence: {
        title: 'Excellence',
        content: 'We aim for excellence in every detail: from the efficiency of our booking system to the quality of our vehicles, including the professionalism of our drivers.'
      },
    }
  },
  vehicle: {
    passengers: 'passengers',
    luggages: 'luggage',
    skodaSuperbDesc: 'Comfortable and economical sedan, perfect for urban and business travel.',
    toyotaPriusDesc: 'Eco-friendly hybrid vehicle with excellent comfort for all your city trips.',
    mercedesEDesc: 'Luxury sedan for your business trips or special events.',
    mercedesVDesc: 'Spacious van ideal for groups and families with lots of luggage.',
    features: {
      leather: 'Leather interior',
      clim: 'Air conditioning',
      wifi: 'Free WiFi',
      usb: 'USB charger',
      baby: 'Baby seat available',
      ecolo: 'Eco-friendly',
      cardPayment: 'Card payment',
      premium: 'Premium service',
      wheelchair: 'Wheelchair accessible space',
      group: 'Perfect for groups'
    }
  },
  ourVehicles: {
    title: 'Our Fleet',
    description: 'TaxiMoove has a diverse fleet to meet all your transportation needs. Our vehicles are recent, regularly maintained and driven by professional drivers.',
    why: 'Why choose our fleet',
    values: {
      recent: {
        title: 'Recent vehicles',
        content: 'Our fleet consists exclusively of recent vehicles (less than 3 years old) to guarantee you comfort and reliability.'
      },
      maintenance: {
        title: 'Regular maintenance',
        content: 'All our vehicles are meticulously maintained and cleaned before each ride to offer you an impeccable experience.'
      },
      equipment: {
        title: 'Premium equipment',
        content: 'Free WiFi, water bottles, phone chargers... We think of everything to make your journey as pleasant as possible.'
      }
    }
  },
  team: {
    cofounder: 'Co-Founder',
	driver: 'Driver',
    eliasDesc: 'Elias co-founded TaxiMoove with a clear vision: to offer superior quality transportation service with a focus on customer satisfaction.',
    moukrimDesc: 'Moukrim oversees all daily operations, ensuring perfect coordination between our drivers and our clients to guarantee impeccable service.'
  },
  ourTeam: {
    title: 'Our Team',
    description: 'At TaxiMoove, our team is our greatest asset. Composed of passionate and experienced professionals, each member shares the same vision: to offer you an exceptional transportation experience. Discover the people who work every day to make your journey a pleasant and worry-free moment.',
    values: {
      title: 'Our team values',
      subtitle: 'Our team shares fundamental values that guide our actions and our daily service.',
      excellency: {
        title: 'Excellence',
        content: 'Every member of our team is committed to providing excellent service, exceeding customer expectations on every trip.'
      },
      professional: {
        title: 'Professionalism',
        content: 'Our drivers and administrative staff demonstrate impeccable professionalism in all their interactions.'
      },
      cohesion: {
        title: 'Team spirit',
        content: 'We work together, in synergy, to ensure a smooth and coordinated experience for all our clients.'
      }
    }
  },
  transport: {
    standard: {
      title: 'Standard Transport',
      description: 'Our standard transport service is designed to meet all your daily travel needs with a superior level of service and comfort. Whether it\'s for a business trip, an important appointment, or a night out in the city, we guarantee you an impeccable experience.',
      values: {
        quality: {
          title: 'Comfort and Quality',
          content: 'All our vehicles are recent, air-conditioned and perfectly maintained to guarantee you optimal comfort. Our courteous and professional drivers are at your service to make your journey pleasant.'
        },
        reservation: {
          title: 'Easy Booking',
          content: 'Book your ride in just a few clicks via our website or mobile app. You can also contact us by phone for immediate or future booking.'
        },
        available: {
          title: 'Availability',
          content: 'Our service is available 24/7 to meet all your transportation needs, regardless of the time or day. You can count on us at any time.'
        },
      },
      footer: {
        title: 'Good to Know',
        content: 'For our regular customers, we offer advantageous subscription packages. Contact us to learn more about our personalized offers for individuals and businesses.'
      }
    },
    airport: {
      title: 'Airport & Station Transfers',
      description: 'Our airport and station transfer service offers you a reliable and comfortable solution for all your journeys to and from the main transport infrastructures in Belgium. We handle the tracking of your flight or train and adapt our service accordingly.',
      airport: {
        title: 'Airports served',
        subtitle: 'We provide transfers to and from all major Belgian airports:',
        bru: 'Brussels Airport (BRU)',
        crl: 'Charleroi Airport (CRL)',
        anvers: 'Antwerp Airport',
        ostende: 'Ostend-Bruges Airport',
        lgg: 'Liège Airport (LGG)'
      },
      station: {
        title: 'Stations served',
        subtitle: 'We also provide transfers to and from the main train stations in Belgium:',
        bruMidi: 'Brussels-Midi Station',
        bruCentral: 'Brussels-Central Station',
        bruNorth: 'Brussels-North Station',
        anvers: 'Antwerp-Central Station',
        gand: 'Ghent-Saint-Pierre Station',
        louvain: 'Leuven Station',
        malines: 'Mechelen Station',
        bruges: 'Bruges Station'
      },
      values: {
        track: {
          title: 'Real-time tracking',
          content: 'We track the status of your flight or train in real time to adapt to any delays without additional charges. Your driver will wait for you, even in case of significant delays.'
        },
        reservation: {
          title: 'Advance booking',
          content: 'Book your transfer in advance to guarantee your pickup. Simply provide your flight or train number and we take care of the rest.'
        }
      },
      footer: {
        title: 'Important',
        content: 'For airport transfers, we recommend booking at least 24 hours in advance. For international arrivals, your driver will wait for you at the exit of the baggage claim area with a sign bearing your name.'
      }
    },
    parcel: {
      title: 'Parcel Transfer',
      description: [
        'Our parcel transfer service offers you a fast, reliable and secure solution for delivering your parcels and important documents. Ideal for businesses and individuals who need an express delivery service.',
        'With TaxiMoove, you benefit from a personalized service, real-time tracking and careful handling of your shipments. Our team of experienced drivers is committed to meeting the shortest possible deadlines to meet your needs.'
      ],
      features: {
        express: {
          title: 'Express Delivery',
          content: 'We guarantee a fast delivery service for all your urgent parcels and documents. Our team is committed to meeting the shortest possible deadlines to meet your needs.'
        },
        security: {
          title: 'Maximum Security',
          content: 'Your parcels are handled with the utmost care by our trained drivers. We ensure complete traceability and real-time tracking of your shipment.'
        },
        speed: {
          title: 'Fast Service',
          content: 'Our service is available 24/7 to meet your urgent needs. Book online or by phone for immediate pickup.'
        },
        personalized: {
          title: 'Personalized Service',
          content: 'We adapt our service to your specific needs, whether for bulky, fragile parcels or those requiring special transport conditions.'
        },
        region: {
          title: 'Complete Coverage',
          content: 'Service available throughout the Brussels region and in Flanders. We ensure punctual and reliable deliveries to destination.'
        },
        tracking: {
          title: 'Real-Time Tracking',
          content: 'Track the status of your delivery in real-time thanks to our traceability system. Receive notifications at each stage of your shipment.'
        }
      },
      footer: {
        title: 'Important',
        content: [
          'To guarantee optimal service, we recommend that you:',
          [
            'Pack your parcels correctly for transport',
            'Provide accurate information about the contents',
            'Clearly indicate the delivery address',
            'Arrange for an available contact at the delivery address'
          ],
          'For businesses making regular shipments, we offer advantageous monthly packages. Contact us for a personalized offer adapted to your shipping volume.'
        ]
      }
    }
  },
  contact: {
    title: 'Contact us',
    subtitle: 'We are here to listen to all your questions',
    name: {
      label: 'Full name',
      placeholder: 'Your name'
    },
    email: {
      label: 'Email',
      placeholder: 'Your email'
    },
    phone: {
      label: 'Phone',
      placeholder: 'Your phone'
    },
    subject: {
      label: 'Subject',
      placeholder: 'Subject of your message'
    },
    message: {
      label: 'Message',
      placeholder: 'Your message'
    },
    action: {
      submitting: 'Sending...',
      submit: 'Send message'
    },
    success: 'Your message has been sent successfully. We will respond to you as soon as possible.'
  },
  becomeDriver: {
    title: 'Become a TaxiMoove Driver',
    description: 'Join our team of professional drivers and enjoy a flexible career with attractive income. At TaxiMoove, we value professionalism and service excellence.',
    requirements: {
      vehicle: {
        title: 'Personal Vehicle',
        content: 'Own a personal vehicle in excellent condition, recent and well-maintained. The vehicle must meet our quality and comfort criteria.'
      },
      experience: {
        title: 'Professional Experience',
        content: 'Have at least 2 years of professional driving experience. Experience in passenger transport is a plus.'
      },
      documents: {
        title: 'License and Documents',
        content: 'Hold a valid driving license for more than 3 years. No criminal record and clean criminal background check.'
      },
    },
    benefits: {
      title: 'The Benefits of Joining TaxiMoove',
      money: {
        title: 'Attractive Income',
        content: 'Enjoy competitive income with bonuses and tips. Earn more by working during peak hours.'
      },
      flexibility: {
        title: 'Complete Flexibility',
        content: 'Manage your schedule as you wish. Choose your working hours and areas.'
      },
      support: {
        title: 'Continuous Support',
        content: 'Benefit from 24/7 technical and administrative support. Continuous training and growth opportunities.'
      },
    },
    apply: 'Apply Now'
  },
  search: {
    services: {
      transport: 'Transport',
      transfer: 'Transfer',
      parcel: 'Parcel'
    },
    vehicles: {
      economy: 'Economy',
      standard: 'Standard',
      van: 'Van'
    },
    capacity: 'people',
    origin: {
      label: 'Origin',
      placeholder: 'Departure address'
    },
    destination: {
      label: 'Destination',
      placeholder: 'Arrival address'
    },
    startDate: 'Departure date',
    startTime: 'Departure time',
    returnDate: 'Return date',
    returnTime: 'Return time',
    flightNumber: 'Flight number',
    nametag: 'Nametag',
    weight: 'Weight',
    dimensions: 'Dimensions',
    description: {
      label: 'Description',
      placeholder: 'Parcel description'
    },
    distance: 'Distance',
    duration: 'Duration',
    error: {
      noDataFound: 'No travel information found. Please perform a new search.',
      noSelectedVehicle: 'Please select a vehicle to continue.'
    },
    action: {
      addReturn: 'ADD RETURN',
      loading: 'Loading...',
      book: 'Book now'
    }
  },
  payment: {
    title: 'Secure payment',
    name: 'Name on card',
    phone: 'Phone',
    card: 'Card details',
    action: {
      processing: 'Processing...',
      pay: 'Pay',
      loading: 'Loading...',
      return: 'Return'
    },
    success: 'Payment successful! Redirecting...',
    notice: 'Secure payment with Stripe. Your card data is encrypted.',
    error: {
      noDataFound: 'No booking information found. Please perform a new search.'
    },
    summary: 'Order summary',
    services: {
      label: 'Service',
      transport: 'Transport',
      transfer: 'Transfer',
      parcel: 'Parcel'
    },
    vehicle: 'Vehicle',
    itinerary: 'Itinerary',
    date: 'Date',
    return: 'Return',
    flightNumber: 'Flight number',
    weight: 'Weight',
    dimensions: 'Dimensions',
    description: 'Description',
    total: 'Total',
    secure: 'Secure payment',
    methods: {
      select: 'Payment method',
      card: 'Bank card',
      paypal: 'Paypal',
      bancontact: 'Bancontact'
    }
  },
  paymentReturn: {
    redirect: 'Automatic redirection in a few seconds...',
    retry: 'Retry',
    goHome: 'Back to home',
    status: {
      success: 'Payment Successful',
      error: 'Payment Error',
      processing: 'Processing'
    },
    statusDesc: {
      success: 'Your payment has been processed successfully. Your order is being processed...',
      error: 'Payment Error',
      processing: 'Your payment is being processed. Please wait...'
    },
    errors: {
      general: 'An error occurred while verifying the payment.',
      canceled: 'The payment was canceled. You can retry if you wish.',
      requiresPaymentMethod: 'Your payment could not be processed. Please try with another payment method.',
      unknown: 'The payment status is unknown. Please contact support if necessary.'
    }
  },
  paymentSuccess: {
    title: 'Payment Confirmed',
    subtitle: 'Thank you for your booking!',
    confirmationCode: 'Your confirmation code is:',
    details: {
      title: 'Your booking details'
    },
    price: 'Amount paid',
    instructionsTitle: 'What happens now?',
    instructions: [
      'A confirmation email has been sent to your address.',
      'Our team will contact you to confirm your booking details.',
      'For any questions, don\'t hesitate to contact us.'
    ],
    returnHome: 'Return to home',
    contactUs: 'Contact us'
  },
  profile: {
    accountInfo: 'Account Information',
    editProfile: 'Edit Profile',
    savedAddresses: 'Saved Addresses',
    paymentMethods: 'Payment Methods',
    security: 'Security',
    changePassword: 'Change Password',
    twoFactorAuth: 'Two-Factor Authentication',
    preferences: 'Preferences',
    language: 'Language',
    appearance: 'Appearance',
    silentRide: 'Silent Ride',
    petFriendly: 'Pet-Friendly Ride',
    notifications: 'Notifications',
    other: 'Other',
    referral: 'Referral',
    legal: 'Legal',
    logout: 'Logout',
    title: 'My Profile',
    theme: 'Theme',
    help: 'Help & Support'
  },
  password: {
    title: 'Change Password',
    current: 'Current Password',
    new: 'New Password',
    confirm: 'Confirm Password',
    change: 'Change Password',
    mismatch: 'Passwords do not match',
    tooShort: 'Password must be at least 8 characters long',
    changeError: 'Error changing password',
    changeSuccess: 'Password changed successfully',
  },
  language: {
    title: 'Choose Language',
    french: 'French',
    english: 'English',
  },
  theme: {
    title: 'Choose Theme',
    light: 'Light',
    dark: 'Dark',
  },
  referral: {
    title: 'Referral Program',
    yourCode: 'Your Referral Code',
    description: 'Share your referral code with friends and earn rewards!',
    copy: 'Copy',
    copied: 'Copied!',
    referrals: 'Referrals',
    earned: 'Earned',
    pending: 'Pending',
  },
  legal: {
    title: 'Legal',
    terms: {
      title: 'Terms and Conditions',
      lastUpdated: 'Last updated: March 1st, 2024',
      intro: 'By using our service, you agree to the following terms:',
      terms1: 'You must be at least 18 years old to use this service',
      terms2: 'You are responsible for maintaining the confidentiality of your account',
      terms3: 'We reserve the right to modify these terms at any time',
    },
    privacy: {
      title: 'Privacy Policy',
      intro: 'We take the protection of your personal data very seriously.',
      points1: 'We only collect data necessary for the operation of the service',
      points2: 'Your data is never sold to third parties',
      points3: 'You can request the deletion of your data at any time',
    },
    cookies: {
      title: 'Cookie Policy',
      intro: 'We use cookies to improve your experience.',
      types1: 'Essential cookies for site functionality',
      types2: 'Analytics cookies to improve our services',
      types3: 'Preference cookies to save your choices',
    },
    contact: {
      title: 'Contact',
      email: 'Email: contact@taximoove.com',
      address: 'Address: 123 Peace Street, 75000 Paris',
      phone: 'Phone: +33 1 23 45 67 89',
    },
  },
  help: {
    title: 'Help & Support',
    chat: {
      title: 'Live Chat',
      description: 'Chat in real-time with our support team',
      welcome: 'Hello! How can we help you today?',
      placeholder: 'Type your message...',
      autoResponse: 'Thank you for your message. A member of our team will respond shortly.'
    },
    phone: {
      title: 'Phone Support',
      description: 'Call us for immediate assistance',
      hours: 'Monday - Friday: 9:00 AM - 6:00 PM',
      availability: 'Available in France and internationally'
    },
    email: {
      title: 'Email Support',
      description: 'Send us an email and we\'ll get back to you as soon as possible',
      subject: 'Subject',
      subjectPlaceholder: 'Enter your message subject',
      message: 'Message',
      messagePlaceholder: 'Describe your request in detail',
      send: 'Send'
    },
    faq: {
      title: 'Frequently Asked Questions',
      searchPlaceholder: 'Search in FAQs...',
      questions: {
        q1: 'How do I book a trip?',
        q2: 'How can I modify a booking?',
        q3: 'What payment methods are accepted?',
        q4: 'How do I cancel a booking?',
        q5: 'How do I become a driver?'
      },
      answers: {
        a1: 'To book a trip, log in to your account, select your pickup and dropoff locations, choose your vehicle, and confirm the booking.',
        a2: 'You can modify your booking up to 1 hour before the trip by accessing the "My Trips" section of your account.',
        a3: 'We accept credit cards (Visa, Mastercard, American Express), PayPal, and bank transfers.',
        a4: 'To cancel a booking, go to the "My Trips" section, select the relevant trip, and click "Cancel".',
        a5: 'To become a driver, fill out the registration form in the "Become a Driver" section and submit the required documents.'
      }
    }
  },
  footer: {
    about: {
      title: 'About',
      ourStory: 'Our story',
      ourVehicles: 'Our fleet',
      ourTeam: 'Our team',
      contact: 'Contact us',
    },
    services: {
      title: 'Services',
      standard: 'Standard Transport',
      airport: 'Airport Transfers',
      parcel: 'Parcel Delivery',
    },
    contact: {
      title: 'Contact',
      email: 'Email',
      phone: 'Phone'
    },
    join: {
      title: 'Join us',
      becomeDriver: 'Become a driver'
    },
    copyright: {
      allRightsReserved: 'All rights reserved.',
      mentions: 'Legal notices',
      terms: 'Terms and conditions',
      confidentiality: 'Privacy policy'
    }
  }
}; 